import { configurationSchema } from '@exam-center/configuration';

export const configuration = configurationSchema.parse({
  mode: import.meta.env.MODE,
  logLevel: import.meta.env.VITE_LOG_LEVEL,
  graphql: {
    apiUrl: import.meta.env.VITE_GRAPHQL_API_URL,
    defaultFetchPolicy: import.meta.env.VITE_GRAPHQL_DEFAULT_FETCH_POLICY,
  },
  loginUrl: import.meta.env.VITE_LOGIN_URL,
  userSessionApiUrl: import.meta.env.VITE_USER_SESSION_API_URL,
  deepLinkUrl: import.meta.env.VITE_DEEP_LINK_URL,
  userManagement: {
    url: import.meta.env.VITE_USER_MANAGEMENT_URL,
    internalUserEmailDomains: import.meta.env.VITE_INTERNAL_USER_EMAIL_DOMAINS,
  },
  examCenter: {
    adminMemberRoleId: import.meta.env.VITE_EXAM_CENTER_ADMIN_MEMBER_ROLE_ID,
    defaultLogoSrc: import.meta.env.VITE_EXAM_CENTER_DEFAULT_LOGO_SRC,
  },
  examinee: {
    importTemplateUrl: import.meta.env.VITE_EXAMINEES_IMPORT_TEMPLATE_URL,
  },
  examEvent: {
    paperAnswer: {
      importTemplateUrl: import.meta.env.VITE_EXAM_EVENT_PAPER_ANSWER_IMPORT_TEMPLATE_URL,
      spreadsheetSheetName: import.meta.env.VITE_EXAM_EVENT_PAPER_ANSWER_SPREADSHEET_SHEET_NAME,
    },
  },
  proctor: {
    agreementFormTemplateUrl: import.meta.env.VITE_PROCTOR_AGREEMENT_FORM_URL,
    agreementFormTemplateUrlTypeOneAndTwo: import.meta.env
      .VITE_PROCTOR_TYPE_ONE_AND_TWO_AGREEMENT_FORM_URL,
    agreementFormTemplateUrlTypeThree: import.meta.env.VITE_PROCTOR_TYPE_THREE_AGREEMENT_FORM_URL,
  },
});
